import { PayloadAction } from "@reduxjs/toolkit";
import { LocationsState } from "../../models/LocationsState";
import { UpdateLocationPayload } from "../../payload/UpdateLocation/UpdateLocationPayload";

const updateLocationFetch = (state: LocationsState, action: PayloadAction<UpdateLocationPayload>) => {
    state.isLoading = true;
}

export default updateLocationFetch;